module.exports = __webpack_public_path__ + "static/media/IMG_3467.95a68632.jpg";